import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const CompleteTaskConfirmationDialog = ({open, handleClose, handleComplete}) => {
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">Are you sure?</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                You're about to mark this task as "completed".
                It will be moved to "success log" and will be read-only. Are you sure you want to do that?
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleComplete}>Complete task</Button>
        </DialogActions>
        </Dialog>
    );
}

export default CompleteTaskConfirmationDialog;
